import { getVNodeFactoryState } from "../../../lib/renderer/utils";
import { getCompPathParentInfo, getLayoutSlot } from "../../../lib/utils";
import { writeClipboard } from "../../../lib/utils/browser/clipboard";
import { isLayout, isLayoutArray } from "../../../lib/utils/layout/isLayout";
import { mapValues, pick } from "lodash-es";
export const copyComponentPropsToClipBoard = designer => {
  const comp = designer.activeComp;
  const payload = JSON.stringify({
    comp: pick(comp, ['props', 'type']),
    copyProps: true
  });
  writeClipboard(payload);
  return payload;
};
export const copyComponentStylesToClipBoard = designer => {
  const comp = designer.activeComp;
  const KEYS = ['type', 'style', 'extraStyle', 'inlineStyleProps', 'styleSheetName'];
  const payload = JSON.stringify({
    comp: pick(comp, KEYS),
    copyStyles: true
  });
  writeClipboard(payload);
  return payload;
};
export const copyComponentToClipBoard = designer => {
  const compPath = designer.getNearestDeletableCompPath(designer.compPath);
  if (!compPath) return;
  const comp = designer.getCompAtPath(compPath);
  const payload = JSON.stringify({
    comp,
    copyStyles: true,
    copyProps: true
  });
  writeClipboard(payload);
  return payload;
};
const normalizeLayout = x => ({
  ...x,
  props: {
    ...x.props
  }
});
const preNormalizeLayout = layout => {
  // 递归
  if (Array.isArray(layout === null || layout === void 0 ? void 0 : layout.children)) {
    layout.children = layout.children.filter(Boolean).map(preNormalizeLayout);
  }
  if ((layout === null || layout === void 0 ? void 0 : layout.slots) instanceof Object) {
    layout.slots = mapValues(layout.slots, value => {
      if (Array.isArray(value)) {
        return value.filter(Boolean).map(preNormalizeLayout);
      }
      return value;
    });
  }
  if ((layout === null || layout === void 0 ? void 0 : layout.scopedSlots) instanceof Object) {
    layout.scopedSlots = mapValues(layout.scopedSlots, value => {
      if ((value === null || value === void 0 ? void 0 : value.layout) instanceof Object) {
        value.layout = preNormalizeLayout(value.layout);
      }
      return value;
    });
  }
  return layout;
};
export const pasteComponentToDesigner = async (str, designer) => {
  var _designer$editZoneSta, _designer$pagelet;
  const {
    comp: x
  } = JSON.parse(str);
  let rawLayout;
  if (Array.isArray(x)) rawLayout = x.map(preNormalizeLayout);else if (x instanceof Object) rawLayout = preNormalizeLayout(x);else rawLayout = x;
  if (isLayoutArray(rawLayout)) rawLayout = rawLayout.map(normalizeLayout);else if (isLayout(rawLayout, true)) rawLayout = normalizeLayout(rawLayout);else throw new Error('Invalid Input');
  let layout = rawLayout;
  let insertPoint = designer.compPath;
  const activeSlotId = (_designer$editZoneSta = designer.editZoneState.currentActiveSlot) === null || _designer$editZoneSta === void 0 ? void 0 : _designer$editZoneSta.id;
  if (activeSlotId) {
    var _getLayoutSlot;
    insertPoint += `/${activeSlotId}/${((_getLayoutSlot = getLayoutSlot(designer.activeComp, activeSlotId, false)) === null || _getLayoutSlot === void 0 ? void 0 : _getLayoutSlot.length) || 0}`;
  }
  while (insertPoint) {
    var _getVNodeFactoryState;
    layout = rawLayout;
    const compInfo = getCompPathParentInfo(insertPoint);
    if (!compInfo) break;
    const slotMeta = (_getVNodeFactoryState = getVNodeFactoryState(designer.renderer, compInfo.parentCompPath)) === null || _getVNodeFactoryState === void 0 || (_getVNodeFactoryState = _getVNodeFactoryState.getNormalSlots()) === null || _getVNodeFactoryState === void 0 ? void 0 : _getVNodeFactoryState.find(x => x.id === compInfo.slotId);
    if (!slotMeta) break;
    const parentLayout = designer.getCompAtPath(compInfo.parentCompPath);
    const beforeDropAns = typeof slotMeta.beforeDrop !== 'function' || slotMeta.beforeDrop({
      layout,
      compMeta: designer.uc.components[parentLayout.type],
      currentLayout: parentLayout
    });
    if (beforeDropAns) {
      if (isLayout(beforeDropAns) || isLayoutArray(beforeDropAns)) layout = beforeDropAns;
      break;
    }
    // ----------------------------------------------------------------
    // bad insert point! shift up!
    insertPoint = compInfo.parentCompPath;
  }
  if (!insertPoint) insertPoint = `/default/${((_designer$pagelet = designer.pagelet) === null || _designer$pagelet === void 0 || (_designer$pagelet = _designer$pagelet.layout) === null || _designer$pagelet === void 0 || (_designer$pagelet = _designer$pagelet.children) === null || _designer$pagelet === void 0 ? void 0 : _designer$pagelet.length) || 0}`;
  const nextInsertPoint = getNextInsertPoint(insertPoint, designer);
  if (nextInsertPoint) insertPoint = nextInsertPoint;
  const newCompPath = await designer.spliceComp([], insertPoint, layout);
  return newCompPath;
};
/** 找到插入点的下一个插入点 */
function getNextInsertPoint(currentCompPath, designer) {
  const coverLayout = designer.getLayoutAtPath(currentCompPath);
  if (coverLayout) {
    // 这时会插入到这个Layout的前面
    // 但是期望上要插入到后面才合理 所以要后移point
    const compPathInfo = getCompPathParentInfo(currentCompPath);
    if (!compPathInfo) return undefined;
    const {
      parentCompPath,
      slotId,
      index
    } = compPathInfo;
    return `${parentCompPath}/${slotId}/${index + 1}`;
  }
  return undefined;
}
//# sourceMappingURL=copyAndPasteComponent.js.map
